import angular from 'angular';
import insuranceAppWorkbenchModal from './insuranceAppWorkbenchModal';

export default angular.module('insuranceAppWorkbench.scenes', [
  insuranceAppWorkbenchModal,
]).name;
